module.exports = __webpack_public_path__ + "static/media/bg-1.7335cf3b.jpg";